import { words } from './allWords';

// Function to get 3 random unique headwords
function getRandomWords(count = 2) {
  const shuffled = words.sort(() => 0.5 - Math.random());
  console.log('shuffled.slice(0, count)', shuffled.slice(0, count))
  const headwords = shuffled.slice(0, count);
  return headwords.map((word) => word.headword);
}

export { getRandomWords };
